/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import GitService from "../../services/gitlab";
import { findJob } from "../../helpers/common"

export default function ClosedMergeRequests({ projectId }) {
  const [mergeRequests, getMRs] = useState([]);
  const [successJobs, setSuccessJobs] = useState([]);

  const getAllMergeRequests = () => {
    GitService.getMergeRequests(projectId, "merged").then((response) => {
      getMRs(response.data);
    });
  };

  const checkIfPublished = (mergeRequest) => {
    const successjob = findJob(successJobs, mergeRequest.merge_commit_sha)
    if(successjob) {
        return true
    }
    return false
  }

  const getAllSuccessJobs = () => {
    GitService.getJobs(projectId, "success").then((response) => {
      setSuccessJobs(response.data);
    });
  };

  useEffect(() => {
    getAllMergeRequests();
    getAllSuccessJobs();
  }, []);

  return (
    <details className="card" open="">
      <summary className="card-header">
        <h5 className="h3 card-title">{`Closed Merge Requests`}</h5>
      </summary>
      <div className="card-body">
        <table className="table">
          <thead>
            <tr>
              <th>Owner</th>
              <th>Name</th>
              <th>Reviewers</th>
              <th>Published</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {mergeRequests.slice(0, 5).map((mergeRequest, index) => {
              return (
                <tr key={index}>
                  <td>{mergeRequest.author.name}</td>
                  <td>{mergeRequest.title}</td>

                  <td>
                    {mergeRequest.reviewers.length > 0 &&
                      mergeRequest.reviewers.map((reviewer, index) => {
                        return <p key={index}>{reviewer.name}</p>;
                      })}
                  </td>
                  <td>
                      {checkIfPublished(mergeRequest) ? <i className="uil uil-check text-success"></i> : <i className="uil uil-times text-danger"></i>}
                  </td>
                  <td className="">
                    <a
                      target="_blank"
                      href={mergeRequest.web_url}
                      className="btn btn-sm btn-primary" rel="noreferrer"
                    >
                      <i className="uil uil-globe"></i>
                      Url
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </details>
  );
}
